module.exports = __webpack_public_path__ + "img/eye-open.487891a5.svg";